const enBackendMessages = {
  InvalidLoginAttempt: 'Invalid username or password',

  // Users
  AccountUserIsLockedOut: 'The user account has been deactivated. ',
  UserEmailAlreadyExist: 'The email already exists.',
  UserNameAlreadyExist: 'The username already exists.',
  PasswordCannotContainsEmail: 'The password could not contain the email address.',
  CurrentPasswordIsWrong: 'The current password is incorrect.',
  NewPasswordEqualsPreviousPassword: 'The new password could not match any of the three previous passwords.',
  UserDoesNotExist: 'The user does not exist.',
  CreateUserAccountUnsuccessful: 'Unable to create user account. Please try again.',
  UpdateUserAccountUnsuccessful: 'Unable to update user account. Please try again.',
  ChangePasswordUnsuccessful: 'Unable to update user password. Please try again.',
  ResetPasswordTokenIsInvalidOrExpired: 'Reset password token is invalid or expired.',
  ResetPasswordUnSuccessful: 'Unable to reset password. Please try again.',
  RefreshTokenInvalid: 'Access token is invalid.',
  // Roles
  UserRoleAlreadyExist: 'The role already exists.',
  RoleDoesNotExist: 'The role does not exist.',
  // Emails
  EmailContentIncorrectFormat: 'Email content has incorrect format.',
  SmtpNotFound: 'SMTP server is not found.',
  InternalErrorDuringSendingEmail: 'Error encountered while sending email.',
  // Country
  CountryCodeAlreadyExist: 'The country code or the short code already exists.',
  ContinentIsInvalid: 'The continent is invalid.',
  // City
  CityNameIsDuplicated: 'The city name already exists.',
  CityCodeIsDuplicated: 'The city code already exists.',
  // Currency
  CurrencyPairAlreadyExist: 'The currency conversion already exists.',
  FromCurrencyCannotBeNull: 'From currency could not be null.',
  ToCurrencyCannotBeNull: 'To currency could not be null.',
  // Hotel Destination Mapping
  HotelDestinationMappingImportFileTypeIsNotSupported: 'The import file type is not supported.',
  HotelDestinationMappingImportSomeRowsAreInvalid: 'Some rows in the import file have an incorrect format.',
  HotelDestinationMappingImportNoRecordFound: 'The record in the import file could not be found.',
  // Agent
  AgentCompanyEmailAlreadyExist: 'The company email already exists.',
  AgentDoesNotExist: 'Agent does not exist.',
  SendAgentStatusUpdatedEmailFailed: 'Unable to send email to the agent.',
  RegisterNewEScottMemberUnSuccessful: 'Unable to add a new credit card.',
  AgentCreditCardMemberDoesNotExist: 'The credit card does not exist.',
  UpdateEScottMemberUnSuccessful: 'Unable to update the credit card.',
  YouDontHavePermissionToUpdateInfoForThisAgent: 'The current agent does not have permission to update this credit card.',
  // Popular hotel settings
  HotelInfoNotFound: 'Unable to get hotel info for all selected hotels.',
  CannotMapOmegaHotelCodeWithNtaHotelCode: 'All selected hotels do not have an NTA Hotel ID.',
  // Landing Slider Setting
  SliderCampaignAlreadyExist: 'The record with the same from and to dates already exists.',
  // Media
  FileUploadIsInvalid: 'The uploaded file is in an invalid format.',
  InternalErrorDuringUploadFile: 'Error occurred during file uploading.',
  FileDownloadIsNotExist: 'The file does not exist.',
  InternalErrorDuringDownloadFile: 'Error occurred during file downloading.',
  // Hotel Mapping
  NoSupplierIdFound: 'Either Jalan Hotel ID or NTA Hotel ID is required.',
  SupplierCodeIsDuplicate: 'The Jalan Hotel ID - NTA Hotel ID pairing already exists.',
  // Cancellation Policy Setting
  PriorDaysIsDuplicate: 'Prior days are duplicates.',
  CheckinDateIsDuplicate: 'The check-in period overlaps with another cancellation policy setting',
  // Booking flow
  CheckOutMustGreaterThanCheckIn: 'The check-out date must be later than the check-in date.',
  RoomCountMustBetween1To3: 'A maximum of 3 rooms are allowed.',
  RoomIndexIsDuplicated: 'Room indexes are duplicates.',
  RoomIndexMustBetween0To2: 'Room index must be between 0 and 2.',
  AdultCountMustBetween1To6: 'The number of adults must be between 1 and 6',
  ChildCountMustBetween0To5: 'The number of children must be between 0 and 5',
  ChildAgesAreRequired: 'Child age is mandatory.',
  TotalPaxPerRoomMustBetween1To6: 'The total number of guests per room must be between 1 and 6.',
  LocationIsInvalid: 'Location could not be found.',
  InvalidSessionId: 'Invalid session ID.',
  HotelMappingNotFound: 'Hotel does not exist.',
  BookingIsNotValidToMakeOnHold: 'The booking is ineligible for putting on-hold.The booking does not satisfy the conditions for being placed on hold',
  NoHotelRoomsAvailable: "We couldn't find any results that match your search criteria.Please modify your search and try again.",
  NoOfRoomForPaxGenderIsInvalid: 'Total number of males and females does not match with number of guest in search.',
  RoomMustBeSameConditionForAllSuppliersMode: "All rooms must have the same booking conditions (number of adults, children, and children's ages).",
  GuestNationalityDoesNotExist: 'Guest Nationality does not exist.',
  CreateBookingInternalException: 'Unable to create a new booking. Please try again.',
  SelectedPaymentMethodDoesNotExist: 'The payment method does not exist',
  UserDoesNotHavePermissionOnThisOrder: 'The current user does not have permission on this order.',
  UserDoesNotHavePermissionOnThisBooking: 'The current user does not have permission on this booking.',
  AgentDoesNotExistOrAlreadySuspended: "Booking could not be made with the current user's permission.",
  CreditCardMemberIsRequiredForCreditCardPayment: 'The preferred credit card is mandatory.',
  LeadPassengerIsRequiredToMakeBooking: 'Lead guest is mandatory.',
  BookingStatusIsNotValidToContinuePartialBooking: 'The partial booking could not be completed for the current booking status.',
  PaymentStatusIsNotValidToContinuePartialBooking: 'The partial booking could not be completed for the current payment status.',
  BookingStatusIsNotValidToCancelPartialBooking: 'The partial booking could not be cancelled for the current booking status.',
  PaymentStatusIsNotValidToCancelPartialBooking: 'The partial booking could not be cancelled for the current payment status.',
  CancelPartialBookingUnSuccessful: 'Unable to cancel the booking. Please try again.',
  CancelBookingUnSuccessful: 'Unable to cancel the booking. Please try again.',
  BookingSessionIsRunning: 'The previous request is still in progress. Please wait for a moment.',
  BookingStatusIsNotValidToCompleteOnHoldBooking: 'On-hold confirmation is not allowed for this booking status.',
  PaymentStatusIsNotValidToCompleteOnHoldBooking: 'On-hold confirmation is not allowed for this payment status.',
  BookingStatusIsNotValidToCancelOnHoldBooking: 'Cancellation is not allowed for this booking status.',
  BookingStatusIsNotAllowToCancel: 'Cancellation is not allowed for this booking status.',
  CancellationFeeChanged: 'Cancellation fee has changed.',
  CancelOnHoldBookingUnSuccessful: 'Unable to cancel the booking. Please try again.',
  BookingContainsNoBookedRoom: 'The booking does not have any reserved rooms.',
  OnHoldPaymentDeadlineIsInvalidWhenConfirmOnHoldBooking: 'The on-hold confirmation deadline has passed.',
  HotelProviderDoesNotExist: 'Hotel provider configuration could not be found.',
  // Booking & order management
  BookingDoesNotExist: 'The booking could not be found.',
  BookingHotelRoomDoesNotExist: 'The hotel room could not be found.',
  BookingHotelDoesNotExist: 'The hotel could not be found.',
  BookingLeadPaxDoesNotExist: 'The lead guest could not be found.',
  BookingContactDetailDoesNotExist: 'The person in charge could not be found.',
  BookingIsNotAllowToResendSuccessBookingEmail: 'Success Email re-sending is not allowed for this booking status.',
  OrderDoesNotExist: 'The order could not be found.',
  SomeSelectedBookingsDoesNotExist: 'Some bookings could not be found.',
  // Manual sync
  BookingStatusIsNotAllowToDoManualSync: 'Manual synchronization is not allowed for this booking status.',
  BookingRoomStatusIsInvalidToDoManualSync: 'Manual synchronization is not allowed for the room status(es).',
  ManualSyncBookingUnSuccessful: 'Manual synchronization of the booking was unsuccessful.',
  AccountUserIsNotActive: 'The user account has been deactivated.',
  UserNameIsRequired: 'Username is required.',
  UserEmailIsRequired: 'Email is required.',
  UserEmailIsNotCorrect: 'Invalid username or email.',
  YouDontHavePermissionToMakeANewBooking: "You don't have permission to make a new booking",
  PrebookHotelFailed: 'We apologize for the inconvenience. The site is currently busy. Please try again later!',
  CannotPrebookHotelWithNonrefundableRooms: 'Sorry, non-refundable rooms cannot be booked at this time. Please select a different room to continue.',
  CheckInDateIsInvalid: 'Check-in date must meet the minimum advance booking requirement.',
  CheckOutDateIsInvalid: 'Check-out date must meet the minimum advance booking requirement.',
  CampaignDateToMustEqualsOrGreaterThanDateFrom: `"Date To" must be the same as or later than "Date From".`,
  CampaignSlugIsInvalid: 'The slug can only include lowercase letters (a-z), numbers (0-9), and hyphens (-).',
  CampaignSlugAlreadyExist: 'The slug is already in use by another campaign.',
  RoomTypeNameAlreadyExist: 'The room type name is already in use. ',
  UserIsLockedForForgotPassword: 'Your account has been locked. Please try again later or contact support for assistance.',
  HotelStarRatingIsInvalid: 'Invalid hotel star rating. Please check and try again.',
  UserLockedForLogin: 'Your account has been temporarily locked after 5 consecutive failed login attempts. Please try again after {{date}}',
  UserAccountWillLocked: 'You have {{count}} consecutive failed login attempts! After 5 failed attempts, your account will be locked for 2 hours.',
};
export default enBackendMessages;
